import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { CalendarCheck } from "lucide-react";

// Persistent mobile-only CTA for the free consultation — kept visible
// through the whole homepage scroll, not just inside the Hero section.
const MobileConsultationBar = () => {
  const navigate = useNavigate();

  return (
    <div
      className="md:hidden fixed bottom-0 left-0 right-0 z-50 px-4 pt-3 border-t border-gray-200"
      style={{
        paddingBottom: "calc(env(safe-area-inset-bottom, 0px) + 0.75rem)",
        background: "#ffffff",
        boxShadow: "0 -4px 20px rgba(0,0,0,0.08)",
      }}
    >
      <Button
        onClick={() => navigate("/konsultacja")}
        className="w-full py-6 text-base font-semibold bg-primary text-white hover:bg-primary/90 rounded-full shadow-lg shadow-primary/25 active:scale-[0.98] transition-all"
      >
        <CalendarCheck className="mr-2 w-4 h-4" />
        Umów bezpłatną konsultację
      </Button>
    </div>
  );
};

export default MobileConsultationBar;
